// Нормы белка и калорий от безжировой массы и обмена веществ рядом с питанием за 7 дней.

import { Card } from '@/components/ui'
import { formatNumber } from '@/lib/format'

import type { NutritionTargets } from '../api'

const n0 = (value: number) => formatNumber(value, { digits: 0 })

function Row({ label, norm, fact }: { label: string; norm: string; fact: string }) {
  return (
    <div className="grid grid-cols-[1fr_auto_auto] items-baseline gap-x-4 py-2 text-sm">
      <span className="text-muted">{label}</span>
      <span className="font-semibold tabular-nums text-fg">{norm}</span>
      <span className="w-32 text-right tabular-nums text-muted">{fact}</span>
    </div>
  )
}

export function NutritionCard({ nutrition }: { nutrition: NutritionTargets }) {
  const { protein_g, protein_min_g, protein_max_g, maintenance_kcal, target_kcal, deficit } = nutrition
  const protein = nutrition.avg_protein_g_7d === null ? 'питание не записано' : `${n0(nutrition.avg_protein_g_7d)} г`
  const kcal = nutrition.avg_kcal_7d === null ? 'питание не записано' : `${n0(nutrition.avg_kcal_7d)} ккал`
  return (
    <Card title="Белок и калории" subtitle="Норма от безжировой массы и обмена веществ; справа — среднее за 7 дней">
      <div className="divide-y divide-border">
        <Row
          label="Белок, г в день"
          norm={`${n0(protein_g)} (${n0(protein_min_g)}–${n0(protein_max_g)})`}
          fact={protein}
        />
        {maintenance_kcal !== null ? (
          <Row label="Поддержание, ккал" norm={n0(maintenance_kcal)} fact={deficit ? '' : kcal} />
        ) : null}
        {deficit && target_kcal !== null ? (
          <Row label="Для снижения жира, ккал" norm={n0(target_kcal)} fact={kcal} />
        ) : null}
      </div>
      {deficit ? (
        <p className="mt-2 text-xs text-muted">
          Есть активная цель на снижение: поддержание минус 15 %, но не ниже обмена веществ.
        </p>
      ) : null}
    </Card>
  )
}
